export class Accordion {
    constructor() {
        this.serviceItems = document.querySelectorAll('.service-item');
        this.handleAccordionClick = this.handleAccordionClick.bind(this);
    }

    toggleAccordion(item) {
        const content = item.querySelector('.service-item__content');
        const isActive = item.classList.contains('active');
        const startHeight = isActive ? content.scrollHeight : 0;
        const targetHeight = isActive ? 0 : content.scrollHeight;
        const duration = 400; // Adjust the duration (in milliseconds) for the slide animation

        let startTime;

        const animate = (timestamp) => {
            if (!startTime) startTime = timestamp;
            const elapsed = timestamp - startTime;
            const progress = Math.min(elapsed / duration, 1);
            const currentHeight = startHeight + (targetHeight - startHeight) * progress;
            content.style.maxHeight = `${currentHeight}px`;

            if (progress < 1) {
                window.requestAnimationFrame(animate);
            } else {
                if (!isActive) {
                    item.classList.add('active');
                    content.style.maxHeight = null;
                } else {
                    content.style.maxHeight = '0';
                    content.addEventListener('transitionend', () => {
                        item.classList.remove('active');
                    }, { once: true });
                }
            }
        };

        content.style.overflow = 'hidden';
        window.requestAnimationFrame(animate);
    }

    closeAllAccordions() {
        this.serviceItems.forEach((item) => {
            const content = item.querySelector('.service-item__content');
            item.classList.remove('active');
            content.style.maxHeight = '0';
            content.style.overflow = 'hidden';
        });
    }

    handleAccordionClick(event) {
        const clickedItem = event.currentTarget;
        this.closeAllAccordions();
        this.toggleAccordion(clickedItem);
    }

    init() {
        this.serviceItems.forEach((item) => {
            item.addEventListener('click', this.handleAccordionClick);
        });
    }
}
